import React from "react";
import "./PageNotFound.css";
import { Link } from "react-router-dom";

const PageNotFound = ({navigate}) => {

    const handleNavigate = (path) => {
        navigate(path);
    }    
  return (
    <div className="not-found-container">
      <h1 className="not-found-title">404</h1>
      <p className="not-found-text">Oops! Page Not Found</p>
      <Link to={"/"} className="not-found-btn">Go Back Home</Link>
    </div>
  );
};

export default PageNotFound;
